import React from 'react';
import { clsx } from 'clsx';

function formatMax(value: number | null | undefined) {
  if (value == null) return '∞';
  return String(value);
}

interface OrganizationUsageBarProps {
  label: string;
  used: number;
  max: number | null | undefined;
  compact?: boolean;
}

export const OrganizationUsageBar: React.FC<OrganizationUsageBarProps> = ({
  label,
  used,
  max,
  compact = false,
}) => {
  const unlimited = max == null;
  const pct = unlimited || !max ? 0 : Math.min(100, Math.round((used / max) * 100));
  const atLimit = !unlimited && max > 0 && used >= max;
  const nearLimit = !unlimited && max > 0 && used / max >= 0.85 && !atLimit;

  return (
    <div className={clsx(compact ? 'space-y-0.5' : 'space-y-1')}>
      <div className="flex justify-between gap-2 text-xs">
        <span className="text-slate-500">{label}</span>
        <span
          className={clsx(
            'tabular-nums font-medium',
            atLimit && 'text-rose-700',
            nearLimit && !atLimit && 'text-amber-700',
            !atLimit && !nearLimit && 'text-slate-700'
          )}
        >
          {used} / {formatMax(max)}
        </span>
      </div>
      {!unlimited && (
        <div className="h-1.5 overflow-hidden rounded-full bg-slate-100">
          <div
            className={clsx(
              'h-full rounded-full transition-all',
              atLimit && 'bg-rose-500',
              nearLimit && !atLimit && 'bg-amber-500',
              !atLimit && !nearLimit && 'bg-slate-700'
            )}
            style={{ width: `${pct}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default OrganizationUsageBar;
